/*
 * Common Messages
 *
 * This contains all the text for the common component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'Taco.common';

export default defineMessages({
  loading: {
    id: `${scope}.components.indicator.loading`,
    defaultMessage: 'Loading...',
  },
  license: {
    id: `${scope}.components.layout.footer.license`,
    defaultMessage: 'This project is licensed under the MIT license.',
  },
  author: {
    id: `${scope}.components.layout.footer.author`,
    defaultMessage: `Made with love by {author}.`, //https://emojipedia.org/
  },
  socialLinkTooltip: {
    id: `${scope}.components.sociallink.tooltip`,
    defaultMessage: `Add Social Media`,
  },
  iconListShowMore: {
    id: `${scope}.components.iconList.showMore`,
    defaultMessage: `More`,
  },
  saveBtn: {
    id: `${scope}.components.button.save`,
    defaultMessage: `Save`,
  },
  cancelBtn: {
    id: `${scope}.components.button.cancel`,
    defaultMessage: `Cancel`,
  },
  createBtn: {
    id: `${scope}.components.button.create`,
    defaultMessage: `Create`,
  },
  deleteBtn: {
    id: `${scope}.components.button.delete`,
    defaultMessage: `Delete`,
  },
  deleteAPLBtn: {
    id: `${scope}.components.button.deleteAPLBtn`,
    defaultMessage: `Delete APL`,
  },
  addBtn: {
    id: `${scope}.components.button.addBtn`,
    defaultMessage: `Add`,
  },
  editBtn: {
    id: `${scope}.components.button.editBtn`,
    defaultMessage: `Edit`,
  },
  viewBtn: {
    id: `${scope}.components.button.viewBtn`,
    defaultMessage: `View`,
  },
  tooltipCopy: {
    id: `${scope}.components.button.copy`,
    defaultMessage: `Copy to clipboard`,
  },
  copiedMsg: {
    id: `${scope}.components.button.copiedMsg`,
    defaultMessage: `Copied`,
  },
  tooltipHide: {
    id: `${scope}.components.button.show`,
    defaultMessage: `Show`,
  },
  tooltipShow: {
    id: `${scope}.components.button.hide`,
    defaultMessage: `Hide`,
  },
  copyMsg: {
    id: `${scope}.components.message.copyMsg`,
    defaultMessage: 'Copied',
  },
  tooltipReGenerate: {
    id: `${scope}.components.button.reGenerate`,
    defaultMessage: 'Generate a new one',
  },
  downloadFailed: {
    id: `${scope}.components.message.downloadFailed`,
    defaultMessage: 'Download Failed!',
  },
  dataListErrorMessage: {
    id: `${scope}.components.dataList.errorMessage`,
    defaultMessage: 'Cannot get any data.',
  },

  uploadImage: {
    id: `${scope}.components.editLogo.titleModal`,
    defaultMessage: 'Upload image',
  },
  localImage: {
    id: `${scope}.components.editLogo.localImage`,
    defaultMessage: 'Local Image',
  },
  rivirAssets: {
    id: `${scope}.components.editLogo.rivirAssets`,
    defaultMessage: 'RIVIR Assets',
  },
  useImage: {
    id: `${scope}.components.editLogo.useImage`,
    defaultMessage: 'Use Image',
  },
  submit: {
    id: `${scope}.components.editLogo.submit`,
    defaultMessage: 'Submit',
  },
  listErrorMessage: {
    id: `${scope}.components.dataList.error`,
    defaultMessage: 'Cannot get data',
  },
  activeBtn: {
    id: `${scope}.components.button.active`,
    defaultMessage: `Activate`,
  },
  impersonateLevel: {
    id: `${scope}.components.impersonate.level`,
    defaultMessage: `Level`,
  },
  accountId: {
    id: `${scope}.components.impersonate.accountId`,
    defaultMessage: `Account ID`,
  },
  memberRole: {
    id: `${scope}.components.impersonate.memberRole`,
    defaultMessage: `Member Role`,
  },
});
